import React from 'react';
import { Nav, NavItem, NavLink, Button } from 'reactstrap';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { SearchTab } from './searchTypes';

interface Props {
  tabs: SearchTab[];
  activeTab: string; // <-- note: it's a string ID
  isUrdu: boolean;
  toggleTab: (index: string) => void;
  addNewTab: () => void;
  removeTab: (tabId: string) => void;
}

const TabNavigation: React.FC<Props> = ({
  tabs,
  activeTab,
  isUrdu,
  toggleTab,
  addNewTab,
  removeTab,
}) => {
  const { t } = useTranslation();

  return (
    <Nav tabs className="mb-4">
      {tabs.map((tab, index) => (
        <NavItem key={tab.id}>
          <NavLink
            className={classnames('d-flex align-items-center', {
              active: activeTab === tab.id,
              'fw-bold text-primary': activeTab === tab.id,
            })}
            onClick={() => toggleTab(tab.id)}
            style={{
              cursor: 'pointer',
              backgroundColor: activeTab === tab.id ? '#e9f5ff' : 'transparent',
              borderBottom: activeTab === tab.id ? '3px solid #0d6efd' : '1px solid #dee2e6',
            }}
          >
            {t('Invoice')} {index + 1}
            {tabs.length > 1 && (
              <Button
                color="link"
                size="sm"
                className="ms-2 p-0 text-danger"
                onClick={(e) => {
                  e.stopPropagation();
                  removeTab(tab.id);
                }}
              >
                <i className="bx bx-x" />
              </Button>
            )}
          </NavLink>
        </NavItem>
      ))}
      <NavItem>
        <NavLink onClick={addNewTab} style={{ cursor: 'pointer' }}>
          <i className="bx bx-plus" />
        </NavLink>
      </NavItem>
    </Nav>
  );
};

export default TabNavigation;
